export const YOU_UTM_URL =
  'https://you.com/?utm_campaign=14406778-Udacity%20Partner%20Site%2006June2025&utm_source=Partner&utm_medium=Partner&utm_content=Udacity_AgenticAI_06June2025';
